var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMaxWidth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "14px",
    viewBox: "0 0 17 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Graphics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-1095.000000, -482.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "section-options",
    transform: "translate(822.000000, 415.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(57.000000, 58.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-max-width",
    transform: "translate(217.000001, 9.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6428571,0.7 L14.6428571,13.3",
    id: "Path",
    stroke: "#1495CD",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.357142857,0.7 L0.357142857,13.3",
    id: "Path",
    stroke: "#1495CD",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8571429,7 L2.14285714,7",
    id: "Path",
    stroke: "#1495CD",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#1495CD",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "11.7857143 5.6 13.2142857 7 11.7857143 8.4"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#1495CD",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "3.21428571 8.4 1.78571429 7 3.21428571 5.6"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    cx: 8.92857143,
    cy: 13.3,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    cx: 11.7857143,
    cy: 13.3,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    cx: 6.07142857,
    cy: 13.3,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    cx: 3.21428571,
    cy: 13.3,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    cx: 8.92857143,
    cy: 0.7,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    cx: 11.7857143,
    cy: 0.7,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    cx: 6.07142857,
    cy: 0.7,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    cx: 3.21428571,
    cy: 0.7,
    rx: 1,
    ry: 1
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMaxWidth);
export default __webpack_public_path__ + "static/media/icon-max-width.121095f078621e0ad7ffaebccb85b125.svg";
export { ForwardRef as ReactComponent };